import { UserData } from 'data/types/user';

export const normalizeUser = (data: UserData) => {
  return {
    email: data.email,
    phone: data.phone,
    firstName: data.firstName,
    lastName: data.lastName,
  };
};

export type User = ReturnType<typeof normalizeUser>;
